import * as _ from "lodash";

export interface FileObject {
    id?: string;
    /** Original file name when the object was created from a user File (e.g. uploads). */
    name?: string;
    url: string;
    type: string;
    uploaded?: boolean;
    originalUrl?: string;
    originalPdfUrl?: string;
    patientId?: string;
    patientNoteId?: string;
    displayIndex?: number;
    annotatedVersions?: any[];
    processingStatus?: 'processing' | 'completed' | 'failed';
}

export function mapMediaToFileObject(media: any[], ignoreSorting: boolean = false): FileObject[] {
    if (!media || !media[0]?.mediaUrl) {
        return media;
    }

    // Filter out PDFs, but include PDFs that are processing
    const filteredMedia = _.filter(media, (item) => 
        item.mediaType !== 'application/pdf' || item.processingStatus === 'processing'
    );

    // Sort by displayIndex if sorting is not ignored
    const sortedMedia = ignoreSorting ? filteredMedia : _.sortBy(filteredMedia, ['displayIndex']);

    // Determine latest URL (from annotatedVersions if available)
    const getLatestUrl = (img: any) => {
        if (img.annotatedVersions && img.annotatedVersions.length) {
            const sortedAnnotated = _.orderBy(img.annotatedVersions, ['createdAt'], ['desc']);
            return sortedAnnotated[0].mediaUrl;
        }
        return img.mediaUrl;
    };

    // Map to FileObject format
    return sortedMedia.map((item) => ({
        id: item.id,
        url: getLatestUrl(item),
        type: item.mediaType,
        uploaded: true,
        originalUrl: item.originalUrl,
        originalPdfUrl: item.originalPdfUrl,
        displayIndex: item.displayIndex,
        patientId: item.patientId,
        patientNoteId: item.patientNoteId,
        annotatedVersions: item.annotatedVersions,
        processingStatus: item.processingStatus
    }));
}
